/**
 * Base64 → bytes, for OOXML packages handed back by Office.js
 * (e.g. `slide.exportAsBase64()`).
 */
export function base64ToBytes(base64: string): Uint8Array {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.codePointAt(i) ?? 0;
  return bytes;
}
